/* istanbul ignore file */

import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ConstantsService {
	debounceTime = 1000;

	inputMasks = {
		phone: '000-000-0000',
		zipCode: '00000',
		zipCodePlusFour: '00000-0000',
		canadianPostalCode: 'S0S 0S0',
		integer: '0*',
		password: 'A*'
	};

	fieldLabels = {
		firstName: 'First Name',
		lastName: 'Last Name',
		email: 'Email Address',
		password: 'Password',
		newPassword: 'New Password',
		country: 'Country/Region',
		streetAddress: 'Street Address',
		apartmentAddress: 'Apartment, Suite, Building',
		city: 'City',
		state: 'State',
		province: 'Province',
		zip: 'Zip Code',
		phoneNumber: 'Phone Number',
		postalCode: 'Postal Code',
		canadianPostalCode: 'Canadian Postal Code',
		orderNumber: 'Order Number',
		zipPostal: 'Billing ZIP / Postal Code',
		newEmail: 'New Email Address',
		confirmEmail: 'Confirm Email Address',
		confirmPassword: 'Confirm Password',
		currentPassword: 'Current Password',
		carDetails: 'Vehicle Color & Make',
		confirmNewEmail: 'Re-Enter New Email Address'
	};

	placeholders = {
		carDetails: 'e.g. Silver Ford'
	};

	countries = {
		unitedStates: { abbrev: 'US', text: 'United States' },
		canada: { abbrev: 'CA', text: 'Canada' }
	};

	countriesv2 = {
		unitedStates: { abbrev: 'USA', text: 'United States' },
		canada: { abbrev: 'Canada', text: 'Canada' }
	};

	provinces = [
		{value: 'AB', text: 'AB - Alberta'},
		{value: 'BC', text: 'BC - British Columbia'},
		{value: 'MB', text: 'MB - Manitoba'},
		{value: 'NB', text: 'NB - New Brunswick'},
		{value: 'NL', text: 'NL - Newfoundland and Labrador'},
		{value: 'NS', text: 'NS - Nova Scotia'},
		{value: 'NT', text: 'NT - Northwest Territories'},
		{value: 'NU', text: 'NU - Nunavut'},
		{value: 'ON', text: 'ON - Ontario'},
		{value: 'PE', text: 'PE - Prince Edward Island'},
		{value: 'QC', text: 'QC - Quebec'},
		{value: 'SK', text: 'SK - Saskatchewan'},
		{value: 'YT', text: 'YT - Yukon'}
	];

	states = [
		{value: 'AA', text: 'AA - Armed Forces America'},
		{value: 'AE', text: 'AE - Armed Forces Europe, Middle East, Africa and Canada'},
		{value: 'AK', text: 'AK - Alaska'},
		{value: 'AL', text: 'AL - Alabama'},
		{value: 'AP', text: 'AP - Armed Forces Pacific'},
		{value: 'AR', text: 'AR - Arkansas'},
		{value: 'AZ', text: 'AZ - Arizona'},
		{value: 'CA', text: 'CA - California'},
		{value: 'CO', text: 'CO - Colorado'},
		{value: 'CT', text: 'CT - Connecticut'},
		{value: 'DC', text: 'DC - District of Columbia'},
		{value: 'DE', text: 'DE - Delaware'},
		{value: 'FL', text: 'FL - Florida'},
		{value: 'GA', text: 'GA - Georgia'},
		{value: 'HI', text: 'HI - Hawaii'},
		{value: 'IA', text: 'IA - Iowa'},
		{value: 'ID', text: 'ID - Idaho'},
		{value: 'IL', text: 'IL - Illinois'},
		{value: 'IN', text: 'IN - Indiana'},
		{value: 'KS', text: 'KS - Kansas'},
		{value: 'KY', text: 'KY - Kentucky'},
		{value: 'LA', text: 'LA - Louisiana'},
		{value: 'MA', text: 'MA - Massachusetts'},
		{value: 'MD', text: 'MD - Maryland'},
		{value: 'ME', text: 'ME - Maine'},
		{value: 'MI', text: 'MI - Michigan'},
		{value: 'MN', text: 'MN - Minnesota'},
		{value: 'MO', text: 'MO - Missouri'},
		{value: 'MS', text: 'MS - Mississippi'},
		{value: 'MT', text: 'MT - Montana'},
		{value: 'NC', text: 'NC - North Carolina'},
		{value: 'ND', text: 'ND - North Dakota'},
		{value: 'NE', text: 'NE - Nebraska'},
		{value: 'NH', text: 'NH - New Hampshire'},
		{value: 'NJ', text: 'NJ - New Jersey'},
		{value: 'NM', text: 'NM - New Mexico'},
		{value: 'NV', text: 'NV - Nevada'},
		{value: 'NY', text: 'NY - New York'},
		{value: 'OH', text: 'OH - Ohio'},
		{value: 'OK', text: 'OK - Oklahoma'},
		{value: 'OR', text: 'OR - Oregon'},
		{value: 'PA', text: 'PA - Pennsylvania'},
		{value: 'RI', text: 'RI - Rhode Island'},
		{value: 'SC', text: 'SC - South Carolina'},
		{value: 'SD', text: 'SD - South Dakota'},
		{value: 'TN', text: 'TN - Tennessee'},
		{value: 'TX', text: 'TX - Texas'},
		{value: 'UT', text: 'UT - Utah'},
		{value: 'VA', text: 'VA - Virginia'},
		{value: 'VT', text: 'VT - Vermont'},
		{value: 'WA', text: 'WA - Washington'},
		{value: 'WI', text: 'WI - Wisconsin'},
		{value: 'WV', text: 'WV - West Virginia'},
		{value: 'WY', text: 'WY - Wyoming'}
	];

	errors = {
		orderNotFound: 'We cannot find that order. Please check that you\'ve entered the correct information and try again.',
		emailUnknown: 'We were unable to verify if this email already has an associated account.',
		unknownError: 'An unknown error occurred. Please try again later.',
		invalidAddress: 'USPS could not verify the address you entered.',
		selectOption: 'Please select an option below.',
		requiredCredentials: 'To sign in, please enter a valid email address and password.',
		emailNotAccepted: 'Email Address Not Accepted.',
		invalidEmail: 'Please enter a valid email address.',
		unknownErrorTitle: 'Unknown Error',
		unknownErrorBody: 'Refresh the page to try again later.',
		tokenErrorTitle: "Error",
		tokenErrorBody: "Refresh the page to try again",
		verificationCodeErrorTitle: "Verification Code Error",
		verificationCodeErrorBody: "The verification code is wrong or has expired. Resend and try again.",
	};

	cookies = {
		wcsApi: {
			loginIn: 'WCS_API_LOGIN_ID',
			userId: 'WCS_API_USER_ID',
			token: 'WCS_API_TOKEN',
			trustedToken: 'WCS_API_TRUSTED_TOKEN',
			personalizationId: 'WCS_API_PERSONALIZATION_ID'
		}
	};

	urls = {
		credit: {
			manageAccount: 'https://dsg.syf.com/login/',
			applyToday: 'https://apply.syf.com/applylanding/ApplyLanding?clientCode=DSG'
		}
	};
}
